import { useState, useEffect } from 'react';
import config from '../config';
import { enviarCorreo } from '../helpers/correo.helpers';
import { formatearRut } from '../helpers/formatters';

export function RequerimientoModalContent({ onClose, dataLogin, requerimiento, onImageClick, onAnularClick, handleEditButtonClick, onReenviarClick }) {
  const [visitasTecnicas, setvisitasTecnicas] = useState([]);

  useEffect(() => {
    if (dataLogin?.id_usuario) {
      obtenerVisitasTecnicas(requerimiento.id_requerimiento);
    }
  }, [dataLogin]);

  const obtenerVisitasTecnicas = async (id_requerimiento) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/visita_tecnica.php?id_requerimiento=${id_requerimiento}`
      );
      const data = await response.json();

      if (data && data[0].id_requerimiento) {
        setvisitasTecnicas(data);
      }
    } catch (error) {
      setvisitasTecnicas([]);
    }
  };

  const handleReenviarCorreo = async () => {
    const formCorreo = {
      email: requerimiento.email_solicitante,
      nombre_cliente: requerimiento.nombre_cliente,
      nombre_obra: requerimiento.nombre_obra,
      nombre_contacto: requerimiento.nombre_contacto,
      nombre_requerimiento: requerimiento.nombre_requerimiento,
      detalle: requerimiento.detalle,
      fecha_requerimiento: requerimiento.fecha_requerimiento,
      id_requerimiento: requerimiento.id_requerimiento
    };

    try {
      const data = await enviarCorreo(formCorreo);
      if (data.message === "El correo electrónico ha sido enviado correctamente.") {
        alert("Correo reenviado correctamente.");
      }
    } catch (error) {
      alert("Error al reenviar el correo.");
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">Detalles Requerimiento</h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body">
          <div className="row row-cols-lg-2">
            <div className="col">
              <ul className="list-group mb-4">
                <li className="list-group-item d-flex justify-content-between align-items-center gap-2">
                  <span className="form-label mb-0">Nombre Requerimiento</span>
                  <span className="label text-end">{requerimiento.nombre_requerimiento || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center gap-2">
                  <span className="form-label mb-0">Cliente</span>
                  <span className="label text-end">{requerimiento.nombre_cliente || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center gap-2">
                  <span className="form-label mb-0">Rut</span>
                  <span className="label text-end">{formatearRut(requerimiento.rut_cliente) || ""}</span>
                </li>
              </ul>
            </div>
            <div className="col">
              <ul className="list-group mb-4">
                <li className="list-group-item d-flex justify-content-between align-items-center gap-2">
                  <span className="form-label mb-0">Obra</span>
                  <span className="label text-end">{requerimiento.nombre_obra || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center gap-2">
                  <span className="form-label mb-0">Contacto</span>
                  <span className="label text-end">{requerimiento.nombre_contacto || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center gap-2">
                  <span className="form-label mb-0">Fecha</span>
                  <span className="label text-end">{requerimiento.fecha_requerimiento || ""}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mb-4">
            <h5 className="mb-3">Detalle</h5>
            <div className="bg-white border rounded fw-bold py-2 px-3">{requerimiento.detalle || ""}</div>
          </div>
          <h5 className="mb-3">Visitas Tecnicas</h5>
          <div className="table-responsive border rounded">
            <table className="table table-hover mb-0">
              <thead>
                <tr className="table-active border-bottom">
                  <th scope="col" className="ps-3">Fecha</th>
                  <th scope="col">Detalle</th>
                  <th scope="col" className="pe-3">Imagen</th>
                </tr>
              </thead>
              <tbody>
                {visitasTecnicas.length > 0 ? (
                  visitasTecnicas.map((visitaTecnica, index) => (
                    <tr key={index}>
                      <td className="ps-3">{visitaTecnica.fecha_visita || ""} {visitaTecnica.id_visita || ""}</td>
                      <td>{visitaTecnica.detalle}</td>
                      <td className="pe-3">
                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => onImageClick(visitaTecnica.id_visita)}><i className="bi bi-images"></i> Ver Imágenes</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center ps-1" colSpan={3}>No se encontraron visitas técnicas asociadas</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">

                    
          <button
            className="btn btn-outline-danger"
            onClick={() => onAnularClick(requerimiento.id_requerimiento, requerimiento.nombre_requerimiento)}>
            <i className="bi bi-dash-circle"></i> Anular
          </button>

          <button
            className="btn btn-outline-dark"
            onClick={() => onReenviarClick(requerimiento)}>
            <i className="bi bi bi-send"></i> Reenviar correo
          </button>

          <button
            className="btn btn-dark"
            onClick={() => handleEditButtonClick("Requerimientos", requerimiento, visitasTecnicas)}>
            <i className="bi bi-pencil-square"></i> Editar
          </button>
        </div>
      </div>
    </div>
  );
}